import { render, staticRenderFns } from "./view_student.vue?vue&type=template&id=dd484404&scoped=true"
import script from "./view_student.vue?vue&type=script&lang=ts"
export * from "./view_student.vue?vue&type=script&lang=ts"
import style0 from "./view_student.vue?vue&type=style&index=0&id=dd484404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd484404",
  null
  
)

export default component.exports